__turbopack_context__.v({
  "beamDown": "FlowBeam-module__qrLdRq__beamDown",
  "container": "FlowBeam-module__qrLdRq__container",
  "glow": "FlowBeam-module__qrLdRq__glow",
  "node": "FlowBeam-module__qrLdRq__node",
  "nodePulse": "FlowBeam-module__qrLdRq__nodePulse",
  "stream": "FlowBeam-module__qrLdRq__stream",
  "streams": "FlowBeam-module__qrLdRq__streams",
});
